import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class';

@Component({})
export default class CashbackTooltip extends Vue {

  @Prop({ default: "30px" }) iconWidth;
  @Prop({ default: "30px" }) iconHeight;
  @Prop({ default: false }) hasTooltip;
  @Prop({ default: "" }) message;
  @Prop({ default: 'bottom' }) position;

  @Getter getIsToken: any;

  isTooltipVisible = false;

  _goToCashbackInfo() {

  }

  get getTooltipMessage() {
    return this.message;
  }
}